import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
// import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {RequireMenuAccess} from './RequireMenuAccess'

// import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

const PrivateRoutes = () => {
  // const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  // const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  // const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  // const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const MenuPage = lazy(() => import('../modules/apps/menu/MenuPage'))
  const LovPage = lazy(() => import('../modules/apps/lov/LovPage'))
  const LogPage = lazy(() => import('../modules/apps/logs/LogPage'))
  const CallPage = lazy(() => import('../modules/apps/call/CallPage'))
  const BlastPage = lazy(() => import('../modules/apps/blast/BlastPage'))
  const TicketPage = lazy(() => import('../modules/apps/ticket/TicketPage'))
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* <Route path='builder' element={<BuilderPageWrapper />} /> */}
        {/* <Route path='menu-test' element={<MenuTestPage />} /> */}
        {/* Lazy Modules */}
       
        <Route
          path='apps/ticket/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <TicketPage />
            </SuspensedView>          
          </RequireMenuAccess>
          }
        />
        <Route
          path='apps/blasting/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <BlastPage />
            </SuspensedView>
          </RequireMenuAccess>
          }
        />
        <Route
          path='apps/call/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <CallPage />
            </SuspensedView>
          </RequireMenuAccess>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          </RequireMenuAccess>
          }
        />
        <Route
          path='apps/logs/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <LogPage />
            </SuspensedView>
          </RequireMenuAccess>
          }
        />
        <Route
          path='apps/menu/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <MenuPage />
            </SuspensedView>
          </RequireMenuAccess>
          }
        />
        <Route
          path='apps/lov/*'
          element={
          <RequireMenuAccess>
            <SuspensedView>
              <LovPage />
            </SuspensedView>
          </RequireMenuAccess>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}
const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}
export {PrivateRoutes}